import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/zqweather/Index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "weather",
    component: HomeView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
